import React from "react";

import styles from "./InputRadio.module.css";

interface InputRadioProps {
  label?: string;
  name?: string;
  value?: string;
  className?: string;
  inline?: boolean;
  checked?: boolean;
  required?: boolean;
  disabled?: boolean;
  onChange?: (value: string) => void;
}

const InputRadio = ({
  label = "",
  name = "",
  value = "",
  className = "",
  inline = false,
  checked = false,
  required = false,
  disabled = false,
  onChange,
}: InputRadioProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <label
      className={`${styles.input} ${inline ? styles.inline : ""} ${className}`}
    >
      <input
        type="radio"
        value={value}
        name={name}
        className="mr-3"
        checked={checked}
        required={required}
        disabled={disabled}
        onChange={handleChange}
      />
      {label}
    </label>
  );
};

export default InputRadio;
